import React from 'react'

import CenterContent from '../../../widgets/components/CenterContent'
import ContactWidget from '../../../widgets/contact'
import HeadingWidget from '../../../widgets/heading'
import TextWidget from '../../../widgets/text'

const OfferDefaultBody = ({ offer, locations }) => {
  const { motabilityPrice, motabilityDownpayment } = offer

  return (
    <div>
      {offer.isMotability && motabilityDownpayment && (
        <HeadingWidget
          heading={'Motability Details'}
          title={`${motabilityPrice}`}
          text={`${motabilityDownpayment}`}
          theme={'dark'}
          container={CenterContent}
        />
      )}

      {offer.sell && (
        <HeadingWidget title={offer.sell} container={CenterContent} />
      )}
      <TextWidget container={CenterContent} html={offer.description} />

      <ContactWidget
        internalEmailType={'contact'}
        text={
          'Please complete the form and remember to include your email address and/or telephone number so that a member of our sales team can contact you as soon as possible.'
        }
        locations={locations}
        selectedLocations={offer.dealerships.map(({ _id }) => _id)}
        additionalInfoLabel={'My question'}
        theme={'blue'}
        title={'ENQUIRE ABOUT THIS OFFER'}
      />

      <TextWidget container={CenterContent} html={offer.termsAndConditions} />
    </div>
  )
}

export default OfferDefaultBody
